import React, { useState } from 'react';
import PacientesScreen from './PacientesScreen';
import PerfilNeuroterapeuta from './PerfilNeuroterapeuta';

export default function NeuroDashboard({ token, user, onLogout }) {
  const [showPerfil, setShowPerfil] = useState(false);
  const [selectedPaciente, setSelectedPaciente] = useState(null);

  // Callback para mostrar detalles/notas del paciente
  const handlePacienteSelect = paciente => setSelectedPaciente(paciente);
  const handleCloseDetalles = () => setSelectedPaciente(null);

  // Refresca datos tras editar perfil (opcional: puedes volver a pedir al backend si lo deseas)
  const handleUpdate = () => {
    alert('Perfil actualizado. Recarga para ver los cambios reflejados en la sesión.');
  };

  return (
    <div className="App">
      <h2>Bienvenido{user.nombre ? `, ${user.nombre}` : ''}</h2>
      <button onClick={onLogout}>Cerrar sesión</button>
      <button onClick={() => setShowPerfil(p => !p)} style={{ marginLeft: 8 }}>
        {showPerfil ? 'Ver pacientes' : 'Editar mi perfil'}
      </button>
      <div style={{ marginTop: 24 }}>
        {showPerfil ? (
          <PerfilNeuroterapeuta token={token} usuario={user} onUpdate={handleUpdate} />
        ) : (
          <PacientesScreen token={token} usuario={user} onPacienteSelect={handlePacienteSelect} />
        )}
      </div>
      {/* Panel/Modal para ver detalles y notas del paciente */}
      {selectedPaciente && (
        <div className="modal-paciente" style={{ position: 'fixed', top: 40, left: 0, right: 0, margin: 'auto', maxWidth: 500, background: '#fff', border: '1px solid #ccc', borderRadius: 8, padding: 24, zIndex: 1000 }}>
          <h3>Ficha de {selectedPaciente.nombre}</h3>
          <p><b>Email:</b> {selectedPaciente.email}</p>
          <p><b>Edad:</b> {selectedPaciente.edad}</p>
          <p><b>Género:</b> {selectedPaciente.genero}</p>
          <p><b>Diagnóstico:</b> {selectedPaciente.diagnostico}</p>
          {/* Aquí se mostrarán las notas del paciente */}
          <div style={{ marginTop: 16 }}>
            <b>Notas del paciente:</b>
            <NotasPaciente pacienteId={selectedPaciente.id} token={token} />
          </div>
          <button onClick={handleCloseDetalles} style={{ marginTop: 16 }}>Cerrar</button>
        </div>
      )}
    </div>
  );
}

// Componente para mostrar las notas del paciente
function NotasPaciente({ pacienteId, token }) {
  const [notas, setNotas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  React.useEffect(() => {
    setLoading(true);
  fetch(`https://api.braineka.com/admin/usuarios/${pacienteId}/notas`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => { setNotas(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => { setError('Error cargando notas'); setLoading(false); });
  }, [pacienteId, token]);

  if (loading) return <div>Cargando notas...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!notas.length) return <div>No hay notas registradas.</div>;
  return (
    <ul style={{ marginTop: 8 }}>
      {notas.map(nota => (
        <li key={nota.id} style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 14 }}>{nota.texto}</div>
          <div style={{ fontSize: 11, color: '#888' }}>{nota.fecha}</div>
        </li>
      ))}
    </ul>
  );
}
